import BaseAPI from '@/apis/base/baseApi'
import commonFn from '@/commons/commonFunction'
import httpClient from '@/apis/base/httpclient'

class ExportAPI extends BaseAPI {
  apiName = 'Export';
  controllerName = 'ExportPortal';
  ProcessAsyncCode = 100; // mã code chỉ dịnh xử lý async
  baseUrl = ''

  constructor () {
    super()
    const me = this
    me.baseUrl = me.getAPIUrl()
  }

  /**
   * Xuất khẩu danh sách
   * @param {*} parameter : tham số
   */
  async export (parameter) {
    const request = {
      url: [this.baseUrl, 'ExportFile'].join('/'),
      data: parameter,
    }

    return await httpClient.postAsync(request, true)
  }

  /**
   * tạo mẫu đơn xin học
   * @param {*} payload
   * @returns
   */
  generateTemplate (payload) {
    const me = this
    const request = {
      url: me.getAPIUrl() + '/template',
      data: payload,
    }
    // delete payload.ImportDictionaryType

    return me.postAsync(request, true)
  }
}

export default new ExportAPI()
